import dayjs from 'dayjs';

export default function useCashFlowStatus() {
  const english = [
    'CANCELLED',
    'PENDING',
    'PAID',
    'OVERDUE',
  ];

  const thai = [
    'ยกเลิก',
    'ดำเนินการ',
    'ชำระแล้ว',
    'เกินกำหนด',
  ];

  const translate = (status: string, date: string) => {
    if (status === 'PENDING' && dayjs(date).isBefore(dayjs(new Date()))) return thai[3];
    return thai[english.indexOf(status)];
  };

  const cashFlowStatusClassMap = (status: string, date: string) => {
    switch (status) {
      case 'CANCELLED':
        return 'block text-gray-600 rounded-xl text-xs py-1 text-center bg-gray-200';
      case 'PENDING':
        if (dayjs(date).isBefore(dayjs(new Date()))) return 'block text-white rounded-xl text-xs py-1 text-center bg-red-400';
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-500';
      case 'PAID':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      default: return '';
    }
  };

  return {
    english,
    thai,
    translate,
    cashFlowStatusClassMap,
  };
}
